<template>
	<div>
		<span class="content-box-title">
			Tabela de Preços - {{ tipo | tipo}}
		</span>
		<div class='content-box'>            
			<div class="box-body no-padding">
				<div class="row">
					<div class="col-md-12 right v-padding">
						<button class="btn btn-success" data-toggle="modal" data-target="#newPrice">{{button_novo_item_caption}}</button>    
					</div>          
				</div>
				<table class="table table-striped" id='standard_tables'>
					<thead>
						<tr>     						
							<th>Prazo</th>
							<th>Descrição</th>
							<th>Crédito</th>
							<th>Parcela</th>
							<th>1/2 Parcela</th>
							<th>Taxa de adesão</th>
							<th v-if='acl.level=="admin"'>Ações</th>              
						</tr>
					</thead>
					<tbody id="usuarios_tbody">
						<tr v-for='preco in precos' :key='preco.id'>
							<td>{{ preco.meses }} meses</td>
							<td>{{ preco.descricao }}</td>
							<td>{{ preco.credito | valor}}</td>
							<td>{{ preco.parcela | valor }}</td>
							<td>{{ preco.meia_parcela | valor }}</td>
							<td>{{ preco.adesao | valor}}</td>
							<td v-if='acl.level=="admin"'>
								<button class='btn btn-xs btn-orange btn-interval' title='Editar' @click='edit_show(preco.id)'>
									<i class='fa fa-edit'></i>
								</button>															
								<button class='btn btn-xs btn-red btn-interval' title='Excluir' @click='delete_store(preco.id)'>
									<i class='fa fa-trash'></i>
								</button>						
							</td>
						</tr>
					</tbody>
				</table>
			</div>            
		</div>   

		<div class="modal fade" id="newPrice" tabindex="-1" role="dialog" aria-labelledby="newPriceLabel" aria-hidden="true">			
			<div class="modal-dialog" role="document">
				<form @submit.prevent="form.id ==0 ? newPrice_store() : edit_store()" @keydown="form.onKeydown($event)">
					<div class="modal-content">
						<div class="modal-body">
							<span class='content-box-title'>{{ this.modal_title }}</span>
							<input type="hidden" v-model='form.id'>
							<div class="form-group">
								<label>Descrição:</label>								
								<input v-model="form.descricao" type="text" name="descricao"
								class="form-control" :class="{ 'is-invalid': form.errors.has('descricao') }">
								<has-error :form="form" field="descricao"></has-error>
							</div>
							<div class="form-group">
								<label>Prazo:</label>
								<input v-model="form.meses" type="text" name="meses" v-mask="'###'"
								class="form-control" :class="{ 'is-invalid': form.errors.has('meses') }">
								<has-error :form="form" field="meses"></has-error>
							</div>
							<div class="form-group">
								<label>Crédito</label>
								<money class='form-control' v-model='form.credito' v-bind='money' :class="{ 'is-invalid': form.errors.has('credito') }"></money>
								<has-error :form="form" field="credito"></has-error>
							</div>
							<div class="form-group">
								<label>Parcela</label>
								<money class='form-control' v-model='form.parcela' v-bind='money' :class="{ 'is-invalid': form.errors.has('parcela') }"></money>
								<has-error :form="form" field="parcela"></has-error>
							</div>							
							<div class="form-group">
								<label>Meia parcela</label>
								<money class='form-control' v-model='form.meia_parcela' v-bind='money' :class="{ 'is-invalid': form.errors.has('meia_parcela') }"></money>
								<has-error :form="form" field="meia_parcela"></has-error>
							</div>								
							<div class="form-group">
								<label>Adesão</label>
								<money class='form-control' v-model='form.adesao' v-bind='money' :class="{ 'is-invalid': form.errors.has('adesao') }"></money>
								<has-error :form="form" field="adesao"></has-error>
							</div>								

						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
							<button :disabled="form.busy" type="submit" class="btn btn-primary" id="btn_store_new_user">{{this.modal_button_caption}}</button> 
						</div>
					</div>
				</form>
			</div>
		</div>     


	</div>
</template>

<script>

	var api_url = "/api/apiprecos";

	export default {
		props:['tipo'],
		data(){
			return{
				precos:[],
				acl:{},
				form: new Form({
					id:0,
					descricao:"",
					meses:0,
					tipo:"",
					credito:"",
					parcela:"",
					meia_parcela:"",
					adesao:""
				})	,
				money: {
					decimal: ',',
					thousands: '.',
					prefix: 'R$ ',
					// suffix: ' #',
					precision: 2,
					masked: false
				}
			}
		},
		methods:{
			list(){
				axios.get(api_url + "/?tipo=" + this.tipo )
				.then((data)=>{
					console.log(data.data);
					this.precos = data.data;
				});
			},
			newPrice_show(){
				this.form.reset();
				$("#newPrice").modal('show');
			},
			newPrice_store(){
				this.form.tipo = this.tipo;
				this.form.post(api_url)
				.then((data)=>{
					console.log(data.data);
					$("#newPrice").modal('hide');
					this.form.reset();
					Event.$emit('refreshPrecos');

				});
			},
			edit_show(id){
				axios.get(api_url + "/"+id)
				.then((data)=>{
					var preco = data.data;
					this.form.fill(preco);
					$("#newPrice").modal('show');
				});
			},
			edit_store(){
				this.form.put(api_url + "/" + this.form.id)
				.then((data)=>{
					console.log(data.data);
					$("#newPrice").modal('hide');
					this.form.reset();
					Event.$emit('refreshPrecos');
				})
			},
			delete_store(id){
				axios.delete(api_url + "/" + id)
				.then((data)=>{
					console.log(data.data);						
					Event.$emit('refreshPrecos');	
				});			
			},
			get_acl(){
				axios.get('/api/apiusuarios/acl')
					.then((data)=>{
						this.acl = data.data;
					});	
			}
			
		},
		computed:{
			modal_title(){
				if (this.form.id ==0) return this.button_novo_item_caption;
				return this.form.name;
			},
			modal_button_caption(){
				if(this.form.id==0) return "Cadastrar";
				return "Atualizar";
			},
			button_novo_item_caption(){
				if (this.tipo=='imoveis') return "Nova carta de imóvel";
				return "Nova carta de automóvel";
			}
		},
		watch:{
			tipo: function(newTipo,OldTipo){
				this.list();
			},

		},
		created() {
			this.list();
			this.get_acl();
			Event.$on('refreshPrecos',()=>{
				this.list();
			})
		}
	}
</script>
